export const SHIPPING_PUBLISH = 'publishShipping'
export const SHIPPING_DELETE = 'deleteShipping'
export const SHIPPING_EDIT = 'editShipping'
export const SHIPPING_RESET_STATE = 'resetShippingState'
export const CHECK_AUTH = 'checkAuth'
export const COMMENT_CREATE = 'createComment'
export const COMMENT_DESTROY = 'destroyComment'
export const FAVORITE_ADD = 'addFavorite'
export const FAVORITE_REMOVE = 'removeFavorite'
export const FETCH_SHIPPING = 'fetchShipping'
export const FETCH_SHIPPING_GUEST = 'fetchShippingGuest'
export const FETCH_SHIPPINGS = 'fetchShippings'
export const RESET_SHIPPINGS = 'resetShippings'
export const FETCH_COMMENTS = 'fetchComments'
export const FETCH_PROFILE = 'fetchProfile'
export const FETCH_PROFILE_FOLLOW = 'fetchProfileFollow'
export const FETCH_PROFILE_UNFOLLOW = 'fetchProfileUnfollow'
export const FETCH_TAGS = 'fetchTags'
export const FETCH_SALES = 'fetchSales'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const REGISTER = 'register'
export const UPDATE_USER = 'updateUser'
export const DELETE_USER = 'deleteUser'
export const CHANGE_PASSWORD = 'changePassword'
export const FETCH_PAYMENT_METHODS = 'fetchPaymentMethods'
export const PAYMENT_METHOD_CREATE = 'createPaymentMethod'
export const PAYMENT_METHOD_UPDATE = 'updatePaymentMethod'
export const PAYMENT_METHOD_DELETE = 'deletePaymentMethod'
export const FETCH_ADDRESSES = 'fetchAddresses'
export const FETCH_ADDRESS = 'fetchAddress'
export const FETCH_PLATFORMS = 'fetchPlatforms'
export const FETCH_PLATFORM = 'fetchPlatform'
export const ADDRESS_CREATE = 'createAddress'
export const ADDRESS_UPDATE = 'updateAddress'
export const ADDRESS_DELETE = 'deleteAddress'
export const APPLICATION_DELETE = 'deleteApplication'
export const PLATFORM_DELETE = 'deletePlatform'
export const PLATFORM_AUTHORIZE = 'authorizePlatform'
export const FETCH_FAQ = 'fetchFaq'
export const FETCH_FAQS = 'fetchFaqs'
